module.exports = __webpack_public_path__ + "img/newsLogo3.885525cc.png";